<tr *ngFor="let headerRow of headers; let i = index">
  <th class="table-header fixed-header-1" style="width:120px;" [attr.rowspan]=headers?.length *ngIf="i == 0 && indexCons.show">S.No
  </th>
  <th *ngFor="let header of headerRow; let i = index" [ngClass]="header?.class || 'fixed-header-1'"
    [attr.rowspan]="header?.rows" [attr.colspan]="header?.cols">
    <div class="d-flex align-items-center justify-content-between flex-nowrap">
      <span class="flex-fill" *ngIf="header.hasMultiColumnFilter">
        <i class="px-1" *ngIf="header.name != 'Options' && header.name != 'check'" [ngClass]="getSortIconClass(header)"
          (click)="header?.sortable ? sortHeader(header) : ''"></i>
      </span>

      <span class="flex-fill ml-2">{{header.name != 'check' ? header.name: '' }}</span>
      <input *ngIf="header.name == 'check'" type="checkbox" name="checkall" [checked]="checkAll" [(ngModel)]="checkAll"
        (change)="checkStatus($event)">
      <span class="d-flex align-items-center">
        <ng-container body="container" *ngIf="header.hasMultiColumnFilter">
          <i style="cursor: pointer;" [ngClass]="[header.sortIndex === i && !header.showPopOver ? 'bx bx-filter' : 'bx bx-filter']"
            [ngbPopover]="popContent" class="icon py-3"
            [placement]="[header.sortIndex < averageValue ? 'bottom-left' : 'bottom-right']" triggers="manual" #p="ngbPopover"
            (click)="toggleChevron(header, p)" (hidden)="onPopOverClose(header)">
          </i>
        </ng-container>
      </span>
    </div>

  </th>
</tr>

<ng-template #popContent>
  <div class="md-form mt-0 mb-1">
    <input class="form-control" type="text" placeholder="Search" [(ngModel)]="searchText"
      (keyup)="searchColumnValues()">
  </div>
  <div class="d-flex justify-content-between custom-btns" *ngIf="!noRecords">
    <ul>
      <li class="nav-item" >
        <a (click)="selectAll()" class="nav-link pointer" [class.active]="isSelectAllActive">Select All</a>
      </li>
      <li class="nav-item" >
        <a (click)="unselectAll()" class="nav-link pointer" [class.active]="isUnselectAllActive">Clear All</a>
      </li>
    </ul>
    
    <!-- <button class="btn btn-primary rounded-pill" (click)="selectAll()">
      Select All
    </button>
    <button class="btn btn-secondary rounded-pill" (click)="unselectAll()">
      Clear All
    </button> -->
  </div>
  <ul class="list-group" *ngIf="noRecords">
    <li class="list-group-item">
      <span class="text-center">No Data to Display</span>
    </li>
  </ul>
  <ul class="list-group">
    <li class="list-group-item" *ngFor="let colValue of filteredColumnRecords">
      <div class="d-flex justify-content-start gap-2">
        <input style="cursor: pointer;" type="checkbox" name="{{colValue.value}}" value="{{colValue.value}}" class="mr-3"
          [checked]="colValue.isChecked" (change)="filterTableRows(colValue)">
        <span class="text-word-break">{{colValue.value}}</span>
      </div>
    </li>
  </ul>
</ng-template>
